import axios from "axios";
import { useEffect, useState } from "react";
import SideMenu from "../Components/SideMenu";

export default function Dashboard() {
  const [data, setData] = useState(null);
  const [recentActivity, setRecentActivity] = useState([]);
  useEffect(() => {
    document.title = "Dashboard - IMS";
    // Fetch dashboard data here
    axios.get(`${process.env.REACT_APP_API_URL}/dashboard`,
      {
        headers: { "Authorization": `Bearer ${window.localStorage.getItem("token")}` }
      }
    )
      .then(response => {
        console.log("Dashboard data:", response.data);
        setData(response.data);
        const formattedActivity = response.data.recentActivities.map(activity => {
          return `${activity.seller} sold ${activity.item} for ${activity.price}`;
        })
        setRecentActivity(formattedActivity)
        // You can set this data to state if needed
      })
      .catch(error => {
        console.error("Error fetching dashboard data:", error);
      });


  }, [])

  function toggleMenu(e) {
    e.preventDefault();
    const menu = document.querySelector('.side-menu');
    menu.classList.toggle('hidden');
  }


  return (

    <div className="App">
      <header className="App-header">
        <section className="top-left-corner">
          <img src="https://pub-a3772f2b02704b91829728f4cc7bbe15.r2.dev/logo(new).svg" className="logo" alt="logo" />
          <p>
            MVP
          </p>
        </section>
        <button className="menu-btn" onClick={toggleMenu}>&#9776;</button>
        {/* <button onClick={clearToken} className="clear-token-btn">Clear Token</button> */}
        <SideMenu />

      </header>
      <main>
        <div id="dashboard">
          <h2>Dashboard</h2>
          <div className="stats-cards">

            <StatsCard title="📊 Sold This Month" value={data ? `ETB ${data.soldProducts}` : "..."} />
            <StatsCard title="🏷️ Available Stock" value={data ? 50 - data.unusedCodes : "..."} />
            <StatsCard title="🏷️ Unused QR codes" value={data ? data.unusedCodes : "..."} />
          </div>
          <hr />
          <section>
            <h3>Recent activity</h3>

            <div className="recent-activity">
              {
                recentActivity.length === 0 ? <p>No recent activity</p> :
                  recentActivity.map((activity, index) => (
                    <p key={index}>{activity}</p>
                  ))
              }
            </div>
          </section>
          <hr />
          <section>
            <h3>Highest Selling Products</h3>
            <div className="recent-activity">
              <p>Coming Soon</p>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}


function StatsCard({ title, value }) {
  return (
    <div className="stats-card">
      <p>{title}</p>
      <h3>{value}</h3>
    </div>
  );
}
